import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { GetFileByPathCommand, MusicOnHoldClient, MusicOnHoldDto, AudioClient } from '../../System-api';
import { UploadMusicOnHoldComponent } from '../../portal/customer-role/queue/updatequeue/music/upload_music_on_hold.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-music-on-hold',
  templateUrl: './music-on-hold.component.html',
  styleUrls: ['./music-on-hold.component.scss']
})
export class MusicOnHoldComponent {
    @Input() musicOnHolds: MusicOnHoldDto[] = [];
    @Input() selectedMohId: number;
    @Output() selectedMohChange = new EventEmitter<number>();
    @Output() refreshList = new EventEmitter();
    @Input() loadingMOH: boolean = false;

    @ViewChild('audioPlayer') audioPlayer: ElementRef;
    currentMusic: any = null;
    isPlaying = false;
  
    constructor(
      private dialogService: NbDialogService,
      private toastrService: NbToastrService,
      private musicOnHoldClient: MusicOnHoldClient,
      private audioClient: AudioClient
    ) {}
  
    ngOnInit() {
    }
  
    playMusic(path: string, event: MouseEvent) {
      event.stopPropagation();
      const audioElement = this.audioPlayer.nativeElement;
  
      if (this.currentMusic === path && this.isPlaying) {
        this.isPlaying = false;
        audioElement.pause();
        audioElement.currentTime = 0;
      } else {
        this.currentMusic = path;
        this.loadAudio(path);
      }
    }
  
    private loadAndPlayMusic(path: string, audioElement: HTMLAudioElement) {
      audioElement.src = path + '?' + Date.now();
      audioElement.load();
      audioElement.play();
      this.isPlaying = true;
    }
  
    handleMusicSelection(event: any) {
      if (event.id === 0) {
        this.openUploadDialog();
      } else {
        this.selectedMohChange.emit(event.id);
      }
    }
  
    openUploadDialog() {
      const uploadDialog = this.dialogService.open(UploadMusicOnHoldComponent, {
        closeOnBackdropClick: false,
        autoFocus: false,
        context: {
          isUpdate: false,
          musicOnHold: null,
          title: 'Upload Music On Hold'
        }
      });
      uploadDialog.onClose.subscribe(() => {
        if (this.selectedMohId == 0) {
          this.selectedMohId = null;
        }
      });
      uploadDialog.componentRef.instance.onAdd.subscribe(newId => {
        this.refreshList.emit();
        setTimeout(() => {
          this.selectedMohChange.emit(newId); 
        }, 100);
        uploadDialog.close();
      });
    }
  
    updateMusicOnHold(event: MouseEvent, item: MusicOnHoldDto) {
      event.stopPropagation();
      const updateDialog = this.dialogService.open(UploadMusicOnHoldComponent, {
        closeOnBackdropClick: false,
        autoFocus: false,
        context: {
          musicOnHold: item,
          isUpdate: true,
          title: "Update Music On Hold",
        },
      });
  
      updateDialog.onClose.subscribe(() => this.refreshList.emit());
    }
  
    deleteMusic(event: MouseEvent, item: MusicOnHoldDto) {
      event.stopPropagation();
      this.dialogService.open(ConfirmDialogComponent, {
        autoFocus: true,
        context: {
          question:
            "Music on hold '" + item.displayName + "' will be deleted. Sure?",
          textYes: "Delete",
          textNo: "Cancel",
          statusYes: "danger",
          statusNo: "basic",
        },
      }).onClose.subscribe(confirmed => {
        if (confirmed) {
          this.musicOnHoldClient.delete(item.id).subscribe({
            next: () => {
              this.refreshList.emit();
              this.toastrService.success('Deleted successfully', 'Success');
            },
            error: () => this.toastrService.danger('Deletion failed', 'Error')
          });
        }
      });
    }

    handleClear() {
      this.selectedMohId = null;
      this.selectedMohChange.emit(null);
    }

    loadAudio(path: string) {
      const data = new GetFileByPathCommand();
      data.path = "/audios/wwwroot" + path;
      this.audioClient.getFileByPath(data).subscribe(
        (res) => {
          if (res) {
            this.playLocalAudioFile(path, res);
          } else {
            this.playLocalAudioFile(path);
          }
        },
        (error) => {
          this.playLocalAudioFile(path);
        }
      );
    }

    playLocalAudioFile(path: string, src: string = null) {
      this.audioPlayer.nativeElement.src = src 
        ? "data:audio/mp3;base64," + src 
        : path + "?" + Date.now();
      this.audioPlayer.nativeElement.load();
      this.audioPlayer.nativeElement.play();
      this.isPlaying = true;
    }
}